import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IDatasource, GridApi, GridOptions, IGetRowsParams } from 'ag-grid-community';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { TenantDto } from 'projects/shared/src/lib/models/TenantDto';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { Observable } from 'rxjs';
import { AddTenantDialogComponent } from './add-tenant-dialog/add-tenant-dialog.component';
import { AgGridTenantsSettings } from './AgGridTenantsSettings';
import { DeleteTenantDialogComponent } from './delete-tenant-dialog/delete-tenant-dialog.component';
import { TenantsButtonRendererComponent } from './tenants-button-renderer/tenants-button-renderer.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';


@Component({
  selector: 'manage-tenants',
  templateUrl: './manage-tenants.component.html',
  styleUrls: ['./manage-tenants.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ManageTenantsComponent implements OnInit {

  isAuthenticated$!: Observable<boolean>;
  isAuthenticated!: boolean;
  _tenant!: string;
  gridView = "squirrel";
  squirreldbView!:string;
  tenantdbView!:string;
  _isAdmin!:string;

  rowData1:TenantDto[] = [];
  rowData: TenantDto[] = [];
  ds1!: IDatasource;
  ds!: IDatasource;

  gridApi!: GridApi;
  gridOptions!: GridOptions;
  gridApi1!: GridApi;
  gridOptions1!: GridOptions;
  frameworkComponents: any;
  filter!: GenericFilter;
  aggridSettings!: AgGridTenantsSettings;
  public overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  constructor(public dialog: MatDialog,
    private tenantService: TenantService,
    private oauthService: OAuthServiceService,
    public translate: TranslateService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.isAuthenticated$ = this.oauthService.isLoggedIn;

    this.isAuthenticated$.subscribe({
      next: (isAuthenticated) => {
        this.isAuthenticated = isAuthenticated;
      }
    });

    this.filter = new GenericFilter();
    this.aggridSettings = new AgGridTenantsSettings(this.translate, this.tenantService);
    this.frameworkComponents = { buttonRenderer: TenantsButtonRendererComponent }
    this.gridOptions = this.aggridSettings.agGridUsersSettings;
    this.gridOptions1 = this.aggridSettings.agGridUsersSettings;

    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          let userRoles = data.role as Array<string>;
          userRoles.forEach((dbrole: string) => {
            if (dbrole === 'create_tenant') {
              this._tenant = dbrole;
            }
            else if (dbrole === 'admin' || dbrole  === 'tenant_mode'){
              this._isAdmin = dbrole;
            }
          });
        }
      }
    });

    this.ds = {
      
      rowCount: 0,
      getRows: (params: IGetRowsParams) => {
        this.filter.className = 'tenant';
        this.filter.startRow = params.startRow;
        this.filter.endRow = params.endRow;
        this.filter.sortItems = params.sortModel;
        this.filter.clientFilters = params.filterModel;

        this.gridApi.showLoadingOverlay();
        this.isLoadingResults = true;

        if(this._isAdmin){
          this.tenantService.getTenants(this.filter).subscribe({
            next: (tenants) => {
              this.rowData = tenants;
              this.rowData = this.rowData.slice(params.startRow, params.endRow);
              let lastRow = -1;
  
              if (tenants.length <= params.endRow) {
                lastRow = tenants.length;
              }
              params.successCallback(this.rowData, lastRow);
              this.isLoadingResults = false;
              this.isRateLimitReached = false;
              this.resultsLength = this.rowData.length;
  
              this.gridApi.hideOverlay();
  
              //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["TENANTSRETRIEVED"]}`);
            },
            error: (error: any) => {
              this.isLoadingResults = false;
              this.isRateLimitReached = true;
              this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["TENANTRETRIVALERROR"]}`)
            }
          });
        }
        else
        {
          console.log("manage-tenants: getUserTenants");

          console.log("---------------------------------> calling getUserTenants() from manage-tenant")
          this.tenantService.getUserTenants(this.filter).subscribe({
            next: (tenants) => {
              console.log(tenants)
              this.rowData = tenants;
              this.rowData = this.rowData.slice(params.startRow, params.endRow);
              let lastRow = -1;
  
              if (tenants.length <= params.endRow) {
                lastRow = tenants.length;
              }
              params.successCallback(this.rowData, lastRow);
              this.isLoadingResults = false;
              this.isRateLimitReached = false;
              this.resultsLength = this.rowData.length;
  
              this.gridApi.hideOverlay();
  
              //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["TENANTSRETRIEVED"]}`);
            },
            error: (error: any) => {
              this.isLoadingResults = false;
              this.isRateLimitReached = true;
              this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["TENANTRETRIVALERROR"]}`)
            }
          });
        }
        
      }
    }
  }

  // get tenant(): string {
  //   this.oauthService.userData.subscribe({
  //     next: (data) => {
  //       if (typeof data != undefined && data != null) {
  //         let userRoles = data.role as Array<string>;
  //         userRoles.forEach((dbrole: string) => {
  //           if (dbrole === 'create_tenant') {
  //             this._tenant = dbrole;
  //           }
  //         });
  //       }
  //     }
  //   });
  //   return this._tenant;
  // }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.gridApi.setDatasource(this.ds)
  }

  addTenant() {
    const dialogRef = this.dialog.open(AddTenantDialogComponent, { width: '800px', data: TenantDto });
    dialogRef.afterClosed().subscribe({
      next: (tenant: TenantDto) => {
        this.rowData.splice(2, 0, tenant);
        this.rowData.push(tenant);
        this.gridApi.refreshInfiniteCache();
      },
    });
  }
}
